<div class="header-circle header-circle__primary">
  <span class="header-circle--background"></span>
</div>
